(() => {
  if (customElements.get('tb-video-modal')) return;

  class TbVideoModal extends HTMLElement {
    connectedCallback() {
      this.iframe = this.querySelector('[data-tbvm-iframe]');
      this.video = this.querySelector('[data-tbvm-video]');
      this.closers = this.querySelectorAll('[data-tbvm-close]');
      this.lastTrigger = null;

      this.onKeydown = this.onKeydown.bind(this);
      this.closers.forEach((el) => el.addEventListener('click', () => this.close()));
    }

    parseEmbedUrl(url) {
      if (!url) return null;
      if (url.includes('youtube.com') || url.includes('youtu.be')) {
        let id = '';
        if (url.includes('youtu.be/')) {
          id = url.split('youtu.be/')[1].split('?')[0];
        } else if (url.includes('watch?v=')) {
          id = url.split('watch?v=')[1].split('&')[0];
        } else if (url.includes('/embed/')) {
          id = url.split('/embed/')[1].split('?')[0];
        }
        if (id) return `https://www.youtube.com/embed/${id}?autoplay=1&rel=0&enablejsapi=1`;
      } else if (url.includes('vimeo.com')) {
        const parts = url.split('vimeo.com/')[1] || '';
        const id = parts.split('?')[0].split('/')[0];
        if (id) return `https://player.vimeo.com/video/${id}?autoplay=1`;
      }
      return null;
    }

    // open() accepts either:
    //   open(url, trigger)                   — embed URL string (back-compat with
    //                                          the homepage video carousels).
    //   open({ type, url, poster }, trigger) — explicit descriptor. type 'file'
    //                                          plays a native <video>; anything
    //                                          else goes through the embed path.
    open(source, trigger = null) {
      this.lastTrigger = trigger;

      let type = 'embed';
      let url = '';
      let poster = '';
      if (typeof source === 'string') {
        url = source;
      } else if (source && typeof source === 'object') {
        type = source.type || 'embed';
        url = source.url || '';
        poster = source.poster || '';
      }

      // Reset both players so a previous open() never leaks into this one.
      if (this.iframe) this.iframe.src = 'about:blank';
      this.toggleFile(false);

      if (type === 'file') {
        this.openFile(url, poster);
      } else {
        this.openEmbed(url);
      }

      this.hidden = false;
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', this.onKeydown);

      const focusTarget = this.querySelector('.tbvm__close');
      focusTarget?.focus();
    }

    openEmbed(url) {
      const embed = this.parseEmbedUrl(url);
      if (embed && this.iframe) {
        this.iframe.src = embed;
      } else if (this.video && url) {
        // Fallback: a direct media URL handed to the embed path (not YouTube/
        // Vimeo) still plays natively when a <video> element is present.
        this.openFile(url, '');
      }
    }

    openFile(url, poster) {
      if (!this.video || !url) return;
      this.toggleFile(true);
      if (poster) {
        this.video.setAttribute('poster', poster);
      } else {
        this.video.removeAttribute('poster');
      }
      const sourceEl = this.video.querySelector('source');
      if (sourceEl) {
        sourceEl.src = url;
      } else {
        this.video.src = url;
      }
      this.video.load();
      const playback = this.video.play();
      if (playback && typeof playback.catch === 'function') playback.catch(() => {});
    }

    // Show the native <video> or the embed <iframe>. The iframe is the
    // default-visible player; the file player is only revealed when needed.
    toggleFile(showFile) {
      if (this.video) this.video.hidden = !showFile;
      if (this.iframe) this.iframe.hidden = showFile;
    }

    close() {
      this.hidden = true;
      document.body.style.overflow = '';
      document.removeEventListener('keydown', this.onKeydown);

      if (this.iframe) this.iframe.src = 'about:blank';
      if (this.video) {
        this.video.pause();
        this.video.currentTime = 0;
        const sourceEl = this.video.querySelector('source');
        if (sourceEl) sourceEl.removeAttribute('src');
        this.video.removeAttribute('src');
        this.video.removeAttribute('poster');
      }
      this.toggleFile(false);

      this.lastTrigger?.focus();
      this.lastTrigger = null;
    }

    onKeydown(event) {
      if (event.key === 'Escape') this.close();
    }
  }

  customElements.define('tb-video-modal', TbVideoModal);
})();
